import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Network, ArrowRight } from 'lucide-react';

/**
 * ProtocolBadge — a small, subtle pill that marks an institutional pillar
 * page as part of the HussarAi Protocol doctrine hub.
 *
 * Rendered in the hero area of the three pillar pages:
 *   /operator-zgodnosci · /ai-act-polska · /tarcza-autentycznosci
 *
 * Routes to /protokol-ai (PL canonical) or /ai-protocol (EN alias) based
 * on the active i18n language. Either route resolves to the same page.
 *
 * Visual rules:
 *   • Small pill, low-contrast, no animation.
 *   • Should NOT compete with H1 or primary CTA — caller decides placement.
 *   • Caller passes a `testidPrefix` so each pillar page namespaces its
 *     own badge (e.g. "compliance" → data-testid="compliance-protocol-badge").
 */
const ProtocolBadge = ({ testidPrefix }) => {
  const { t, i18n } = useTranslation();
  const isEn = (i18n.language || 'pl').startsWith('en');
  const to = isEn ? '/ai-protocol' : '/protokol-ai';

  return (
    <Link
      to={to}
      className="hussar-protocol-badge"
      data-testid={`${testidPrefix}-protocol-badge`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 12px',
        borderRadius: 999,
        border: '1px solid rgba(125, 211, 252, 0.22)',
        background: 'rgba(125, 211, 252, 0.04)',
        color: '#7DD3FC',
        fontSize: 11,
        letterSpacing: 0.4,
        fontWeight: 600,
        textDecoration: 'none',
        marginTop: 12,
        marginBottom: 4,
        transition: 'background 120ms ease, border-color 120ms ease',
      }}
    >
      <Network className="w-3 h-3" aria-hidden="true" />
      <span>{t('protocol.partOfBadge')}</span>
      <ArrowRight className="w-3 h-3" aria-hidden="true" />
    </Link>
  );
};

export default ProtocolBadge;
